<template>
  <div class="welcome-modal" :style="style">
    <VpModal ref="modal">
      <template #header>{{ modalTitle }}</template>
      {{ modalBody }}
      <template #footer>
        <VpButton class="primary medium" :style="buttonStyle['cancel']" @click="cancel">{{ $t('cancel') }}</VpButton>
        <VpButton class="primary medium" :style="buttonStyle['proceed']" @click="proceed">{{ $t('welcomeModalSetupProfile') }}</VpButton>
      </template>
    </VpModal>
  </div>
</template>

<script>
export default {
  name: 'WelcomeModal',
  inject: ['$byodConfig'],
  computed: {
    buttonStyle() {
      return {
        cancel: {
          backgroundColor: '#FFFFFF',
          color: this.providerColor,
          border: `${this.providerColor} solid 2px`,
        },
        proceed: {
          backgroundColor: this.providerColor,
        },
      };
    },
    modalBody() {
      const defaultWelcomeBody = this.$i18n.t('welcomeModalDefaultBody', {
        providerName: this.providerName,
        programNames: this.programNames,
      });
      if (this.$byodConfig?.homeAppConfig?.welcomeModalBody) {
        return this.$byodConfig.homeAppConfig.welcomeModalBody;
      }
      return defaultWelcomeBody;
    },
    modalTitle() {
      if (this.$byodConfig?.homeAppConfig?.welcomeModalTitle) {
        return this.$byodConfig?.homeAppConfig?.welcomeModalTitle;
      } return this.$i18n.t('welcomeModalTitle', { providerName: this.providerName });
    },
    providerColor() {
      return this.$byodConfig.color;
    },
    providerName() {
      return this.$byodConfig.shortName;
    },
    programNames() {
      const programNames = this.$store.getters['dashboard/house'].programParticipants
        .map((participant) => {
          return this.$byodConfig.programs.find(program => program.programId === participant.programId)?.programLongName;
        })
        .filter(name => name);
      if (programNames.length > 1) {
        const lastItem = programNames.pop();
        return `${programNames.join(', ')} and ${lastItem}`;
      }
      return programNames;
    },
    style() {
      return {
        '--provider-color': this.providerColor || '#000000',
      };
    },
  },
  methods: {
    cancel() {
      this.$refs.modal.close();
    },
    proceed() {
      this.$router.push('/my-account/profile');
      this.$refs.modal.close();
    },
  },
};
</script>

<style lang="scss">
.welcome-modal {
  .vcl-modal {
    &__title {
      color: var(--provider-color) !important;
    }
  }
}
</style>
